import React from 'react';

const InstallInstructions = () => {
  return (
    <div className="p-4 max-w-md mx-auto mt-20 mb-20">
      <h2 className="text-2xl font-bold mb-6">How to Install the App</h2>

      <p className="mb-4">
        When you visit our site on a supported browser, a install popup may appear at the bottom of your screen asking for a better experience use TGH mobile app.
      </p>

      <p className="mb-4">
        If you don't see this popup or miss it, you can also install the app by tapping the <strong>"Install"</strong> button that appears below the <strong>"How to Install"</strong> link in the menu (hamburger) at the top right corner.
      </p>

      <p className="mb-4 font-semibold">
        If neither the popup nor the button appears, please use the manual installation steps below for your device.
      </p>

      <section className="mb-6">
        <h3 className="text-xl font-semibold mb-2">For Android</h3>
        <ol className="list-decimal list-inside space-y-1">
          <li>Open this website in the Chrome browser.</li>
          <li>Tap the menu button (three dots) in the top-right corner.</li>
          <li>Select <em>"Add to Home screen"</em>.</li>
          <li>Confirm by tapping <em>"Add"</em>.</li>
        </ol>
      </section>

      <section>
        <h3 className="text-xl font-semibold mb-2">For iOS (iPhone/iPad)</h3>
        <ol className="list-decimal list-inside space-y-1">
          <li>Open this website in Safari.</li>
          <li>Tap the Share button (square icon with arrow pointing up) at the bottom.</li>
          <li>Select <em>"Add to Home Screen"</em>.</li>
          <li>Tap <em>"Add"</em> in the top-right corner.</li>
        </ol>
      </section>
    </div>
  );
};

export default InstallInstructions;
